<template>
	<div class="container-news">
		<home-header></home-header>
		<div class="banner-info"></div>
		<div class="menu">
			<mt-navbar v-model="selected">
				<mt-tab-item v-for="( item ,index ) in countryList" :name="index" :key="index" :id="index" @click.native="queryData(item)">{{item.value}}</mt-tab-item>
			</mt-navbar>
			<p class="fenge"></p>
			<!-- tab-container -->
			<mt-tab-container v-model="selected">
				<mt-tab-container-item v-for="(item,index) in countryList" :key="index" :id="index"></mt-tab-container-item>
			</mt-tab-container>
			<div>
				<ul class="news-item" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="120">
					<li class="item" v-for="item of newsInfolist" :key="item.cmsId">
						<router-link :to="{path: '/newsDetails', query: {cmsId:item.cmsId }}">
							<div class="item-img-wrapper">
								<img :src="ImgUrl+item.cmsIco+'&type=thumb'" class="item-image" />
							</div>
							<div class="item-info">
								<p class="item-title">{{item.cmsTitle}}</p>
								<p class="item-time">{{item.createTime|dateFmt('YYYY-MM-DD')}}</p>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
			<div v-show="haveMoreData&&loading" class="loading">
				<mt-spinner type="fading-circle" color="#26a2ff"></mt-spinner>
				<!--加载中-->
			</div>
			<div v-show="!haveMoreData" class="jiazai">已加载完毕 ~</div>
		</div>
		<home-footer></home-footer>
	</div>
</template>
<script>
	import HomeHeader from "@/components/homeHeader";
	import HomeFooter from "@/components/homeFooter";
	import { getList, getData } from "../apis/apis.js";

	export default {
		name: "NewsDetails",
		components: {
			HomeHeader,
			HomeFooter
		},
		data() {
			return {
				selected: 0,
				loading: false,
				ImgUrl: "http://file.hainayx.com/file-server/download?fileUrl=",
				countryList: [],
				nowContry: "1",
				nowPageNum: "1",
				haveMoreData: true,
				newsInfolist: [{
					cmsId: "",
					cmsIco: "",
					createTime: "",
					cmsTitle: "",
					cmsDesc: ""
				}]
			};
		},
		methods: {
			queryData(item) {
				this.nowContry = item.key;
				this.nowPageNum = "1";
				this.haveMoreData = true;
				this.loading = false;
				this.getList(this.nowContry, this.nowPageNum);
			},
			//  获取左侧导航列表
			async getcountryList() {
				let params = {
					dictType: "cms_Type",
					pageSize: "1000",
					pageNum: "1"
				};
				try {
					let {
						data
					} = await getData(params);
					this.countryList = data.data.content;
					if(this.countryList.length > 0) {
						this.nowContry = this.countryList[0].key;
						this.nowPageNum = "1";
						this.getList(this.nowContry, this.nowPageNum);
					}
				} catch(err) {
					console.log(err);
				}
			},
			async getList(key, pageNum) {
				//获取新闻列表
				let params = {
					pageSize: "10",
					pageNum: pageNum,
					cmsType: key,
					cmsCategory:"2",
				};
				try {
					let {
						data
					} = await getList(params);
					if(data.code == 1000) {
						if(data.data.content.length == 0) {
							this.haveMoreData = false;
							//          console.log("--------", this.haveMoreData);
						}
						if(pageNum == "1") {
							this.newsInfolist = data.data.content;
						} else {
							this.newsInfolist = this.newsInfolist.concat(data.data.content);
						}
					} else {
						this.$Message.error(data.message);
					}
				} catch(err) {
					console.log(err);
				}
			},
			//			下划加载出线更多新闻
			loadMore() {
				if(!this.haveMoreData) {
					this.loading = true;
					return;
				}
				console.log("触发了loadMore");
				this.loading = true;
				setTimeout(() => {
					this.nowPageNum++;
					this.getList(this.nowContry, this.nowPageNum);
					console.log("触发loadMore结束");
					this.loading = false;
				}, 1000);
			}
		},
		mounted() {
			this.getcountryList();
		}
	};
</script>
<style scoped>
	.banner-info {
		width: 100%;
		height: 200px;
		background: url("../assets/images/banner002.png");
		background-size: 100% 100%;
	}
	/* tab切换样式 */

	.mint-navbar {
		width: 95%;
		margin: 0 auto;
		height: 90px;
		line-height: 90px;
		overflow-x: auto;
		white-space: nowrap;
	}

	.mint-navbar ::-webkit-scrollbar {
		display: none;
	}

	.mint-navbar .mint-tab-item {
		min-width: 120px;
		height: 90px;
		color: #333;
		padding: 0;
		margin-right: 20px;
	}

	.mint-navbar .mint-tab-item.is-selected {
		font-size: 29px;
		color: #e58111;
		border-bottom: none;
	}

	>>>.mint-tab-item-label {
		font-size: 29px;
		height: 90px;
		line-height: 90px;
	}

	.item {
		height: 203px;
		border-bottom: 1px solid #ccc;
		margin-left: 22px;
		margin-right: 22px;
	}

	.item-img-wrapper {
		width: 228px;
		height: 150px;
		display: inline-block;
		margin-top: 26px;
    overflow: hidden;
	}

	.item-image {
    width: 228px;
    height: 100%;
    object-fit: cover;
	}

	.item-info {
		width: 60%;
		float: right;
		margin-top: 30px;
	}

	.item-title {
		font-size: 29px;
		color: rgba(51, 51, 51, 1);
		line-height: 46px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		height: 95px;
	}

	.item-time {
		font-size: 24px;
		color: #999;
		line-height: 55px;
	}
	/*分割线*/

	.fenge {
		width: 100%;
		height: 12px;
		background: #f2f2f2;
	}
	/*加载中*/

	>>>.mint-spinner-fading-circle-circle {
		left: 340px;
		top: 20px;
		width: 50px;
		height: 50px;
	}

	.loading {
		height: 100px;
		text-align: center;
		line-height: 100px;
	}

	.jiazai {
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #333;
	}
</style>



// WEBPACK FOOTER //
// src/pages/newsList.vue